<template lang="pug">
    v-autocomplete.customer-selector(v-model="select" solo dense hide-details outlined  clearable return-object item-text="name" item-value="id" :items="items"  :placeholder="$t('Placeholder.__Customer')" @click:clear="clearAction" :rules="rules")
        template(v-slot:item="data")
            template(v-if="!isObjectType(data.item)")
                v-list-item-content(v-text="data.item")
            template(v-else)
                v-list-item-content {{ data.item.name }}
        //- template(v-if="insertTag" v-slot:append-item)
        //-     v-divider
        //-     v-list-item.text-left( @click="")
        //-         v-list-item-avatar
        //-             v-icon add
        //-         v-list-item-content
        //-             v-list-item-title 新增客戶
</template>
<script>
// test data
// import customersJSON from "@/test/data/customers.json";

export default {
  props: {
    value: {
      type: Object,
      default: () => {
        return { id: "all_contacts" }
      }
    },
    rules: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      search: null,
      items: [],
      select: [],
      customers: [],
      vendors: []
    }
  },
  watch: {
    search(val) {
      val && val !== this.select && this.querySelections(val)
    },
    value(val) {
      this.select = val
    },
    select(val) {
      if (val) {
        this.$emit("input", val)
      }
    }
  },
  methods: {
    clearAction() {
      this.$emit("input", null)
    },
    async getData() {
      var customers = await this.getCustomers()
      var vendors = await this.getVendors()
      this.items = []
      this.items.push({
        name: this.$t("Reports.__AllContacts"),
        id: "all_contacts"
      })
      this.items.push({ header: this.$t("Transactions.__Customer") })
      this.items = this.items.concat(customers)
      this.items.push({ divider: true })
      this.items.push({ header: this.$t("Transactions.__Vendor") })
      this.items = this.items.concat(vendors)
    },
    getCustomers() {
      return this.$store
        .dispatch("customers/getCustomers", {
          pageNumber: 1,
          pageSize: 999
        })
        .then(
          function(response) {
            response.data.map(customer => {
              customer.type = "customer"
            })
            return Promise.resolve(response.data)
          }.bind(this)
        )
        .catch(
          function(error) {
            return Promise.reject(error)
          }.bind(this)
        )
    },
    getVendors() {
      return this.$store
        .dispatch("vendors/getVendors", {
          pageNumber: 1,
          pageSize: 999
        })
        .then(
          function(response) {
            response.data.map(vendor => {
              vendor.type = "vendor"
            })
            return Promise.resolve(response.data)
            // if (this.name != null) {
            //     this.select = this.vendors.find(item => {
            //         return item.name == this.name
            //     })
            // }
          }.bind(this)
        )
        .catch(
          function(error) {
            return Promise.reject(error)
          }.bind(this)
        )
    },
    querySelections(val) {
      this.items = this.customers.filter(item => {
        return (
          (item.name || "").toLowerCase().indexOf((val || "").toLowerCase()) > -1 ||
          (item.code || "").toLowerCase().indexOf((val || "").toLowerCase()) > -1
        )
      })
    },
    isObjectType(item) {
      return typeof item == "object"
    }
  },
  mounted() {
    this.getData()
    this.select = this.value
  }
}
</script>
